export class InfractionState {
    id:string;
    description:string;

    constructor(id:string, description:string) {
        this.id = id;
        this.description = description;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/infractionState.ts
 **/